import {
ApiHandlerDiscreteParameter,
createHandlerChainRunner,
HasOnError,
HasOnSuccess
} from "@insite/client-framework/HandlerCreator";
import { ADIXtenIntegrationApiParameter, processtoxten } from "@NA/Services/ADIXtenIntegrationService";
import { ADIXtenIntegrationModel } from "@NA/Types/ApiModels";

type ADIXtenIntegrationParameter = {
    Id?: string;
    Type?: string;
    WishListName?: string;
    IsTemp?:boolean;
    ListNameInput?:string;
} & HasOnSuccess<any> & HasOnError;

type HandlerType = ApiHandlerDiscreteParameter<ADIXtenIntegrationParameter, ADIXtenIntegrationApiParameter, ADIXtenIntegrationModel>;
export const SendDataToApi: HandlerType = async props => {
    props.apiResult = await processtoxten({
        Id: `${props.parameter.Id}`,
        Type: `${props.parameter.Type}`,
        WishListName: `${props.parameter.WishListName}`,
        IsTemp: props.parameter.IsTemp,
        ListNameInput: `${props.parameter.ListNameInput}`,
    });
    props.parameter.onSuccess?.(props.apiResult);
};
export const chain = [SendDataToApi];
const ADIXtenIntegrationHandler = createHandlerChainRunner(chain, "ADIXtenIntegrationHandler");
export default ADIXtenIntegrationHandler;
